import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import ComponentsRight from '@blade-sxp/data-mining/pages/companions/components/components-right/index.vue';
import DropDown from '@blade-sxp/data-mining/pages/companions/components/components-left/dropdown.vue';
import deviceSelect from '@blade/common/components/device-cascader-select/index.vue';
import { getDate } from '@blade-sxp/data-mining/utils/date';
import { getAllTaskList, getSearch } from '@blade-sxp/data-mining/apis/index';
// import { dataMining } from '@blade-sxp/data-mining/store/index';
import moment from 'moment';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let default_1 = class default_1 extends Vue {
    form = {
        sec: '10',
        times: '3',
        task: '',
        clusterDbId: '',
        device: [],
        time: [],
        documentId: '',
        deviceName: '',
    };
    param = {
        sec: '10',
        times: '3',
        task: '',
        device: [],
        time: [],
        documentId: '',
        deviceName: '',
        clusterDbId: '',
    };
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    secMin = 3;
    props = { multiple: true, value: 'id', label: 'name' };
    defaultTime = ['00:00:00', '23:59:59'];
    time = [];
    sec = 'S';
    times = 'Times';
    disabled = true;
    taskList = [];
    taskDisabled = false;
    deviceDisabled = false;
    imgList = [];
    timeAhead = '';
    laterTime = '';
    resetForm = false;
    loading = false;
    empty = false;
    isDate = true;
    getEmpty(val) {
        if (!val) {
            return '-';
        }
        return val;
    }
    get rules() {
        return {
            times: [
                {
                    validator: this.getValidatorTime,
                },
            ],
            sec: [
                {
                    validator: this.getValidatorSec,
                },
            ],
        };
    }
    get setPrivacyMode() {
        return this.privacyMode === 'true' ? 6 : 0;
    }
    get pickerOptions() {
        return {
            disabledDate(time) {
                return (moment(time).add(15, 'days').isSameOrBefore(moment().format('YYYY-MM-DD')) ||
                    moment(time).subtract(1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD')));
            },
        };
    }
    reles(val) {
        if (val.device.length) {
            this.taskDisabled = true;
            this.deviceDisabled = false;
        }
        else if (val.task.length) {
            this.deviceDisabled = true;
            this.taskDisabled = false;
        }
        else if (!val.task.length && !val.device.length) {
            this.taskDisabled = false;
            this.deviceDisabled = false;
        }
        if (this.getTimes(val.times) && this.getSec(val.sec) && val.time.length && (val.device.length || val.task.length) && val.documentId) {
            this.disabled = false;
        }
        else {
            this.disabled = true;
            // this.disabled = false;
        }
    }
    mounted() {
        this.initData();
        this.form.time = getDate(this.defaultTime[0], this.defaultTime[1]);
    }
    changeTaskList(val) {
        // console.log('val', val);
        const taskItem = this.taskList.find((item) => {
            return item?.id === val;
        });
        this.form.clusterDbId = taskItem?.bizTaskConfig?.clusterTaskConfig?.clusterDbId;
    }
    sort(a, b) {
        return b.companionsCount - a.companionsCount;
    }
    sortDate(obj) {
        obj.sort((a, b) => {
            let t1 = new Date(Date.parse(a.dateEnd.replace(/-/g, '/')));
            let t2 = new Date(Date.parse(b.dateEnd.replace(/-/g, '/')));
            return t2.getTime() - t1.getTime();
        });
        return obj;
    }
    dateSort() {
        this.imgList = this.sortDate(this.imgList);
        this.isDate = true;
    }
    sortTimes() {
        // 同行次数从多到少排序
        this.imgList.sort(this.sort);
        this.isDate = false;
    }
    initData() {
        // 初始聚档任务
        const param = {
            taskTypes: ['REALTIME_CLUSTER'],
        };
        getAllTaskList(param).then((res) => {
            // dataMining.initTask(res);
            this.taskList = res;
            // console.log('this.taskList', this.taskList);
        });
    }
    // 校验同行次数1-100
    getValidatorTime(i, value, callback) {
        if (this.getTimes(value)) {
            callback();
        }
        else {
            callback(new Error('1-100次'));
        }
    }
    getTimes(val) {
        if (Number(val) >= 1 && Number(val) <= 100) {
            return true;
        }
        return false;
    }
    // 校验同行时间3-30
    getValidatorSec(i, value, callback) {
        if (this.getSec(value)) {
            callback();
        }
        else {
            callback(new Error('3-30s'));
        }
    }
    getSec(val) {
        if (Number(val) >= 3 && Number(val) <= 30) {
            return true;
        }
        return false;
    }
    changeForm(val) {
        // console.log('val', val);
        const { docId, name, portraitImage } = val;
        this.form.documentId = docId;
        this.form.deviceName = name;
        // this.documentTaskId.documentTaskId=
        this.$set(this.form, 'portraitImage', portraitImage);
        this.resetForm = false;
    }
    searchResult(form) {
        const param = {
            documentId: String(form.documentId),
            dateEnd: form.time[1],
            dateStart: form.time[0],
            documentTaskId: [form.task],
            gapSecond: Number(form.sec),
            companionsCount: Number(form.times),
            deviceId: form.device,
        };
        this.param = param;
        this.loading = true;
        this.disabled = true;
        getSearch(param)
            .then((res) => {
            this.isDate = true;
            if (!res.length) {
                this.empty = true;
                this.loading = false;
                this.imgList = res;
            }
            else {
                this.imgList = res;
                this.loading = false;
                this.empty = false;
            }
            this.disabled = false;
        })
            .catch(() => {
            this.disabled = false;
        });
    }
    // changeTask(val: any) {
    //   let newArr: string[] = [];
    //   val.forEach((item: string[]) => {
    //     newArr.push(...item);
    //   });
    //   this.form.task = newArr;
    // }
    reset() {
        this.form = {
            sec: '10',
            times: '3',
            task: '',
            device: [],
            time: getDate(this.defaultTime[0], this.defaultTime[1]),
            deviceName: '',
            documentId: '',
            clusterDbId: '',
        };
        this.resetForm = true;
        this.imgList = [];
        this.empty = false;
        this.isDate = true;
    }
};
__decorate([
    Watch('form', { deep: true })
], default_1.prototype, "reles", null);
default_1 = __decorate([
    Component({
        name: 'data-mining',
        components: { ComponentsRight, DropDown, deviceSelect, BlurPicture },
        i18n: {
            messages: {
                en: {
                    placeholderDevice: 'Please select at least one device',
                    placeholderTask: 'Please select at least one task',
                    device: 'Device',
                    reset: 'Reset',
                    sec: 'S',
                    times: 'Times',
                    title: 'Target Selection',
                    time: 'Time',
                    accompaniedDuration: 'Accompanied Duration',
                    accompaniedTimes: 'Accompanied Times',
                    search: 'Search',
                    fileClusterTask: 'File Cluster Task',
                    targetPortrait: 'Target Portrait',
                    cardName: 'Name',
                },
                zh: {
                    placeholderDevice: '请至少选择一个设备',
                    placeholderTask: '请至少选择一个任务',
                    device: '设备',
                    reset: '重置',
                    sec: '秒',
                    times: '次',
                    title: '目标选择',
                    time: '时间',
                    accompaniedDuration: '同行时间间隔',
                    accompaniedTimes: '同行次数',
                    search: '查询',
                    fileClusterTask: '文件聚档任务',
                    targetPortrait: '目标肖像',
                    cardName: '姓名',
                },
            },
        },
    })
], default_1);
export default default_1;
